const paths = {
    // login
    login: '/entrar',
    register: '/cadastrar',
    recoverAccount: '/recuperar-conta',

    // events
    home: '/',
    createEvent: '/criar-evento',
    trendboard: '/destaques',

    // users
    users: '/usuario/',
    userProfile: '/usuario/:user'
};

export default paths;                   